import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Button/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/@core/components/scroll-to-top/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SettingsProvider"] */ "/app/src/@core/contexts/settingsContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/@layouts/components/horizontal/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/@layouts/components/horizontal/LayoutContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/@layouts/components/vertical/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/@layouts/components/vertical/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/@layouts/LayoutWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/app/src/@layouts/SessionContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/@layouts/styles/horizontal/StyledContentWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/@layouts/VerticalLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HorizontalNavProvider"] */ "/app/src/@menu/contexts/horizontalNavContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VerticalNavProvider"] */ "/app/src/@menu/contexts/verticalNavContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/AuthRedirect.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/horizontal/FooterContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/horizontal/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/shared/DisclaimerUpload.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/shared/GoToHome.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/shared/LanguageDropdown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/shared/ModeDropdown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/shared/PannelloUtenti.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/shared/UserDropdown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/shared/UserState.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/vertical/FooterContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/theme/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BrandProvider"] */ "/app/src/contexts/brandContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NextAuthProvider"] */ "/app/src/contexts/nextAuthProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/libs/styles/AppReactToastify.tsx");
